import {
  Button,
  column,
  Css,
  emptyCell,
  GridColumn,
  GridDataRow,
  GridTable,
  ScrollableContent,
  ScrollableFooter,
  selectColumn,
  simpleHeader,
  useGridTableApi,
} from "@homebound/beam";
import { useMemo } from "react";
import { useParams } from "react-router";
import { SearchBox } from "src/components";
import { TableActions } from "src/routes/layout/TableActions";
import { ProjectParams } from "src/routes/routesDef";
import { noop, queryResult } from "src/utils";
import { ConfirmTradesStepV2_ProjectFragment, useConfirmTradesStepV2Query } from "./ConfirmTradesStepV2.generated";
import { ExitButton } from "./ReleaseToTradesPage";

export function ConfirmTradesStepV2() {
  const { projectId } = useParams<ProjectParams>();
  const query = useConfirmTradesStepV2Query({ variables: { id: projectId } });
  return queryResult(query, ({ project }) => <ConfirmTradesStepV2View project={project} />);
}

type ConfirmTradesStepV2ViewProps = { project: ConfirmTradesStepV2_ProjectFragment };

function ConfirmTradesStepV2View(props: ConfirmTradesStepV2ViewProps) {
  const { project } = props;
  const tableApi = useGridTableApi<Row>();
  const columns = useMemo(() => createColumns(), []);
  const rows = useMemo(() => createRows(), []);
  return (
    <>
      <div css={Css.px8.py3.$}>
        <TableActions>
          <strong>{project.readyPlanConfig?.readyPlan?.displayName ?? ""}</strong>
          <SearchBox onSearch={noop} />
        </TableActions>
        <ScrollableContent virtualized>
          <div css={Css.px5.$}>
            <GridTable
              api={tableApi}
              columns={columns}
              rows={rows}
              as="virtual"
              style={{ allWhite: true, bordered: true, grouped: true, rowHeight: "fixed" }}
              stickyHeader
              fallbackMessage="No line items found."
            />
          </div>
        </ScrollableContent>
      </div>
      <ScrollableFooter>
        <div css={Css.df.px8.py3.bshHover.bgWhite.$}>
          <div css={Css.mla.df.gap2.$}>
            <ExitButton projectId={project.id} developmentId={undefined} />
            <Button size="lg" disabled={false} label={"Submit for approval"} onClick={noop} />
          </div>
        </div>
      </ScrollableFooter>
    </>
  );
}

type Header = { kind: "header" };
type RelevantBidPackageRow = { kind: "relevantBidPackage"; data: { name: string } };
type Row = Header | RelevantBidPackageRow;

function createRows(): GridDataRow<Row>[] {
  return [simpleHeader];
}

function createColumns(): GridColumn<Row>[] {
  return [
    selectColumn({ w: 0.1 }),
    column<Row>({ header: "Cost Code", relevantBidPackage: emptyCell }),
    column<Row>({ header: "Bid Type", relevantBidPackage: emptyCell }),
    column<Row>({ header: "Cost Type", relevantBidPackage: emptyCell }),
    column<Row>({ header: "Total Cost", relevantBidPackage: emptyCell }),
    column<Row>({ header: "Trade", relevantBidPackage: emptyCell }),
    column<Row>({ header: "Existing POs", relevantBidPackage: emptyCell }),
  ];
}
